import { useMutation, useQuery, useQueryClient } from 'react-query'
import useFeatureFlag from '../../hooks/useFeatureFlag'
import { deleteMemory, listMemories } from './memoryApi'

export const CHAT_MEMORY_FEATURE = 'chat-memory'

const MEMORIES_QUERY_KEY = ['memories']

/**
 * The caller's memories: `null` while chat has the feature off for them (its
 * 404), and never fetched while the flag is off here.
 */
export const useMemoriesQuery = () => {
  const isFeatureEnabled = useFeatureFlag(CHAT_MEMORY_FEATURE)
  return useQuery(MEMORIES_QUERY_KEY, listMemories, {
    enabled: isFeatureEnabled,
    // A 404 is an answer (feature off), not a failure to retry.
    retry: false,
    staleTime: 30_000,
  })
}

/**
 * Delete a memory. Shared by the Account page's list and the chat's Saved
 * card, so an Undo in the conversation also refreshes the list. `onFailure`
 * is hook-level, so a later delete can't displace an earlier one's.
 */
export const useDeleteMemoryMutation = (onFailure?: () => void) => {
  const queryClient = useQueryClient()
  return useMutation(deleteMemory, {
    onSuccess: () => queryClient.invalidateQueries(MEMORIES_QUERY_KEY),
    onError: () => onFailure?.(),
  })
}
